<template>
  <span>

    <validation-observer ref="simpleRules">
      <b-form>

        <!-- Image File -->
        <b-form-group
          :label="$t('Add File')"
          label-for="image_file"
        >
          <b-form-file
            :id="`${imageType}_file`"
            v-model="image_file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          />
        </b-form-group>

        <b-button
          variant="primary"
          @click="validationForm"
        >Upload</b-button>
        <b-button
          class="m-2"
          variant="danger"
          @click="deleteImage"
        >Delete</b-button>
      </b-form>
    </validation-observer>

  </span>

</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BFormFile, BButton,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormFile,
    BButton,
  },
  props: {
    imageType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      image_file: null,
    }
  },
  methods: {
    deleteImage() {
      this.$swal({
        title: 'Are you sure?',
        text: 'You are about to delete image...',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          useJwt.axiosIns.delete(`settings/DeleteImage/${this.imageType}`)
            .then(response => {
              if (response.data) {
                this.$emit('deleted')
                this.image_file = null
              }
            })
            .catch(e => {
              console.log(e)
            })
        }
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success && this.image_file) {
          const formData = new FormData()
          formData.append('imageType', this.imageType)
          formData.append('ImageFile', this.image_file)

          useJwt.axiosIns.post('settings/UploadFiles', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {
              if (response.data) {
                this.$emit('submit', response.data)
                this.image_file = null
              }
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          this.$emit('error', 'Select a file!')
        }
      })
    },
  },
}
</script>
